import { DetailsEditor, FormContainer } from "uikit"
import FaqLinks from "components/FaqLinks"
import React from "react"
import { Redirect } from "react-router-dom"
import { Button, Dropdown, Grid } from "semantic-ui-react"
import { accountTypes } from "./accountTypes"
import { useStore } from "store"

const accountTypeOptions = Object.keys(accountTypes).map(accountType => ({
  value: accountType,
  text: accountTypes[accountType].label
}))

const AccountConfirmSelectGrid = ({
  data: {
    fields: { accountType },
    onSubmit,
    hasError,
    error
  },
  submitLabel = "Continue",
  onCancel
}) => {
  const [{ label, description, faqs }] = useStore(
    "contextuals",
    `Screen: accountconfirm`
  )

  return (
    <DetailsEditor
      heading={label}
      description={description}
      supplement={<FaqLinks items={faqs} />}
    >
      <Grid>
        <Grid.Row
          style={{
            background: "#edf7ff",
            padding: "3em",
            borderTop: "1px solid #ccc"
          }}
        >
          <Grid.Column textAlign="center">
            <Dropdown
              placeholder="Select Account Type"
              search
              selection
              options={accountTypeOptions}
              {...accountType}
              error={!!accountType.error}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered>
          <Grid.Column
            width={10}
            textAlign="center"
            style={{ fontSize: "16px", paddingTop: "21px", color: "#aaa" }}
          >
            {accountType.value
              ? accountTypes[accountType.value].description
              : "Please select the type of account you wish to add."}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          style={{ borderTop: "1px solid #ccc", marginTop: "20em" }}
          columns={2}
        >
          <Grid.Column textAlign="left" style={{ paddingLeft: "2em" }}>
            <Button basic content="Cancel" onClick={onCancel} primary />
          </Grid.Column>
          <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
            <Button content={submitLabel} onClick={onSubmit} primary />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </DetailsEditor>
  )
}

const AccountConfirmSelector = FormContainer(
  {
    accountType: {
      type: "string",
      required: true
    }
  },
  (fields, ...form) => {}
)(AccountConfirmSelectGrid)

export default class AccountConfirmSelectContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      accountType: this.props.type
    }
  }
  render = () => {
    return (
      <AccountConfirmSelector
        submit={({ accountType }) => this.setState({ accountType })}
        values={{ accountType: this.state.accountType }}
        success={
          <Redirect
            to={`${this.props.baseUrl}/accounts/${this.props.accountId}/${this.state.accountType}/confirm`}
            push
          />
        }
        onCancel={() => {
          this.props.onCancel()
        }}
      />
    )
  }
}
